<script>
export default {
  name: "advertisementSection",
  data() {
    return {};
  },
  components: {},
  methods: {
    goAdLink(query) {
      window.open(query);
    }
  },
  props: {
    adUrl: String,
    adLink: String
  }
};
</script>

<template>
  <el-row>
    <el-col
      :span="24"
      style="display: flex; justify-content: center; padding: 10px;"
    >
      <el-image :src="adUrl" @click="goAdLink(adLink)" />
    </el-col>
  </el-row>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/reservation/advertisementSection.vue